import {secondAxios} from "../../../api/axios"
import { tokenHeader } from "../../../api/tokenHeader"

export const verifyAccessToken = async ({ token }) => {
    console.log({ token })
    return await secondAxios.post("/dev/verifyToken", tokenHeader(token))
}